module.exports = "<footer class=\"page-footer\" *ngIf=\"isLoggedIn\">\r\n  <div class=\"page-footer-img\"></div>\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row\">\r\n      <a href=\"http://www.solerainc.com/\"><img src=\"../../../assets/img/solera.png\" width=\"262\" aria-hidden=\"true\">\r\n          <span class=\"sr-only\">A Solera Company | www.solerainc.com</span>\r\n      </a>\r\n    </div>\r\n  </div>\r\n</footer>"


//////////////////
// WEBPACK FOOTER
// ./src/app/footer/components/footer.component.html
// module id = ./src/app/footer/components/footer.component.html
// module chunks = main